import {
  HandoffReviewModal,
  QuickBantModal,
} from '@/components/Deals'
import {
  LossConfirmationModal,
  FutureDealModal,
  StageChoiceModal,
  ContractDataModal,
  WinDealModal,
} from '@/components/Deals/DealDetailPanel/Modals'
import type { ContractDataForm, ContractDataModalMode } from '@/components/Deals/DealDetailPanel/contractDataUtils'
import type { Deal, DealStage } from '@/types'
import type { PendingTransition } from './useDealsPageHandlers'

type DealsPageModalsProps = {
  handoffDeal: Deal | null
  onCloseHandoff: () => void
  onHandoffAccept: () => void | Promise<void>
  onHandoffReject: (reason: string) => void | Promise<void>
  showLossModal: boolean
  showFutureModal: boolean
  showWinModal: boolean
  showStageChoiceModal: boolean
  showContractDataModal: boolean
  contractDataDeal: Deal | null
  contractDataModalMode: ContractDataModalMode
  showBantModal: boolean
  pendingTransition: PendingTransition
  onCancelModal: () => void
  onLossSave: (updates: {
    motivoPerda: string
    submotivoPerda?: string
    comentarioPerda?: string
  }) => void | Promise<void>
  onFutureSave: (updates: {
    dataFechamentoPrevisto?: string
    observacoes?: string
  }) => void | Promise<void>
  onWinSave: (updates: { dataFechamento: string; observacoes: string }) => void | Promise<void>
  onStageChoice: (stage: DealStage) => void
  onContractDataConfirm: (form: ContractDataForm) => void | Promise<void>
  onBantSave: (updates: {
    budgetConfirmado: string
    decisorPresente: string
    doresIdentificadas: string
  }) => void | Promise<void>
}

export function DealsPageModals({
  handoffDeal,
  onCloseHandoff,
  onHandoffAccept,
  onHandoffReject,
  showLossModal,
  showFutureModal,
  showWinModal,
  showStageChoiceModal,
  showContractDataModal,
  contractDataDeal,
  contractDataModalMode,
  showBantModal,
  pendingTransition,
  onCancelModal,
  onLossSave,
  onFutureSave,
  onWinSave,
  onStageChoice,
  onContractDataConfirm,
  onBantSave,
}: DealsPageModalsProps) {
  return (
    <>
      {handoffDeal && (
        <HandoffReviewModal
          open={!!handoffDeal}
          onClose={onCloseHandoff}
          deal={handoffDeal}
          onAccept={onHandoffAccept}
          onReject={onHandoffReject}
        />
      )}

      {showLossModal && pendingTransition && (
        <LossConfirmationModal
          open={showLossModal}
          onClose={onCancelModal}
          dealId={pendingTransition.dealId}
          onLost={onLossSave}
        />
      )}

      {showFutureModal && pendingTransition && (
        <FutureDealModal
          open={showFutureModal}
          onClose={onCancelModal}
          dealId={pendingTransition.dealId}
          onScheduled={onFutureSave}
        />
      )}

      {showWinModal && pendingTransition && (
        <WinDealModal
          open={showWinModal}
          onClose={onCancelModal}
          dealId={pendingTransition.dealId}
          onConfirm={onWinSave}
        />
      )}

      {showStageChoiceModal && pendingTransition && (
        <StageChoiceModal
          open={showStageChoiceModal}
          onClose={onCancelModal}
          onSelect={onStageChoice}
        />
      )}

      {showContractDataModal && contractDataDeal && (
        <ContractDataModal
          open={showContractDataModal}
          mode={contractDataModalMode}
          deal={contractDataDeal}
          onClose={onCancelModal}
          onConfirm={onContractDataConfirm}
        />
      )}

      {showBantModal && pendingTransition && (
        <QuickBantModal
          open={showBantModal}
          onClose={onCancelModal}
          dealId={pendingTransition.dealId}
          onSave={onBantSave}
        />
      )}
    </>
  )
}
